(() => {
  if (customElements.get('product-countdown-timer')) return;

  const pad = (n) => String(n).padStart(2, '0');

  const validTz = (tz) => {
    if (!tz || tz === 'local') return null;
    try {
      new Intl.DateTimeFormat('en-US', { timeZone: tz });
      return tz;
    } catch (e) {
      return null;
    }
  };

  const partsIn = (date, tz) => {
    const f = new Intl.DateTimeFormat('en-US', {
      timeZone: tz,
      hourCycle: 'h23',
      year: 'numeric',
      month: 'numeric',
      day: 'numeric',
      hour: 'numeric',
      minute: 'numeric',
      second: 'numeric'
    });
    const p = {};
    f.formatToParts(date).forEach(({ type, value }) => {
      if (type !== 'literal') p[type] = parseInt(value, 10);
    });
    if (p.hour === 24) p.hour = 0;
    return p;
  };

  const offsetOf = (ts, tz) => {
    const base = Math.floor(ts / 1000) * 1000;
    const p = partsIn(new Date(base), tz);
    return Date.UTC(p.year, p.month - 1, p.day, p.hour, p.minute, p.second) - base;
  };

  const wallToTs = (y, mo, d, h, mi, tz) => {
    if (!tz) return new Date(y, mo - 1, d, h, mi, 0).getTime();
    const guess = Date.UTC(y, mo - 1, d, h, mi, 0);
    const first = guess - offsetOf(guess, tz);
    return guess - offsetOf(first, tz);
  };

  const nextLocalMidnight = () => {
    const now = new Date();
    return new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1, 0, 0, 0).getTime();
  };

  class ProductCountdownTimer extends HTMLElement {
    connectedCallback() {
      const raw = (this.dataset.endDate || '').trim().toLowerCase();
      this.daily = raw === 'diario' || raw === 'daily';
      this.els = {
        d: this.querySelector('[data-days]'),
        h: this.querySelector('[data-hours]'),
        m: this.querySelector('[data-minutes]'),
        s: this.querySelector('[data-seconds]')
      };

      if (this.daily) {
        this.hideDays();
        this.target = nextLocalMidnight();
      } else {
        const m = raw.match(/^(\d{4})-(\d{1,2})-(\d{1,2})(?:[ t](\d{1,2}):(\d{2}))?/);
        if (!m) {
          this.style.display = 'none';
          return;
        }
        this.target = wallToTs(+m[1], +m[2], +m[3], +(m[4] || 0), +(m[5] || 0), validTz(this.dataset.timezone));
      }

      this.onVis = () => {
        if (!document.hidden) this.tick();
      };
      document.addEventListener('visibilitychange', this.onVis);

      this.tick();
      this.timer = setInterval(() => this.tick(), 1000);
    }

    disconnectedCallback() {
      clearInterval(this.timer);
      if (this.onVis) document.removeEventListener('visibilitychange', this.onVis);
    }

    hideDays() {
      const unit = this.els.d && this.els.d.closest('.countdown-timer-block__unit');
      if (!unit) return;
      const sep = unit.nextElementSibling;
      unit.style.display = 'none';
      if (sep && sep.classList.contains('countdown-timer-block__separator')) sep.style.display = 'none';
    }

    tick() {
      if (this.daily && this.target - Date.now() <= 0) this.target = nextLocalMidnight();

      const diff = this.target - Date.now();

      if (diff <= 0) {
        this.style.display = 'none';
        clearInterval(this.timer);
        return;
      }

      const t = Math.floor(diff / 1000);
      const days = Math.floor(t / 86400);
      const hours = this.daily ? Math.floor(t / 3600) : Math.floor((t % 86400) / 3600);
      const mins = Math.floor((t % 3600) / 60);
      const secs = t % 60;

      if (this.els.d) this.els.d.textContent = pad(days);
      if (this.els.h) this.els.h.textContent = pad(hours);
      if (this.els.m) this.els.m.textContent = pad(mins);
      if (this.els.s) this.els.s.textContent = pad(secs);
    }
  }

  customElements.define('product-countdown-timer', ProductCountdownTimer);
})();